import { render } from "./FormImage.vue?vue&type=template&id=0cb3d010"
import script from "./FormImage.vue?vue&type=script&lang=js"
export * from "./FormImage.vue?vue&type=script&lang=js"

import "./FormImage.vue?vue&type=style&index=0&id=0cb3d010&lang=scss"
script.render = render

export default script